import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import Viewer from "viewerjs/dist/viewer.esm";
import NoShots from "./components/no-shots";
import { DEFAULT_LOCALE, CODING_SHOT } from "../photography/lib/helpers";
import DownloadImage from "../image-editing/components/download-image";

import { useFileType } from "shared/hooks/use-file-type";

const getShotList = (shots, version) => {
    if (version === "edited") {
        return shots
            .filter((shot) => !!shot.editedBlobKey)
            .map((shot) => {
                return {
                    ...shot,
                    version: "edited",
                };
            });
    }

    if (version === "all") {
        const editedShots = shots
            .filter((shot) => !!shot.editedBlobKey)
            .map((shot) => {
                return {
                    ...shot,
                    version: "edited",
                };
            });

        return [...shots, ...editedShots];
    }

    return shots;
};

const ImageGallery = (props) => {
    const mimeType = useFileType();
    var viewer = null;
    const [shots, setshots] = useState([]);

    useEffect(() => {
        setshots(getShotList(props.shots, props.version));
    }, [props.shots, props.version]);

    const onLoad = () => {
        if (viewer) {
            viewer.destroy();
        }

        viewer = new Viewer(document.getElementById(`image-gallery_${props.wipKey}`), {
            toolbar: {
                zoomIn: 1,
                zoomOut: 1,
                oneToOne: false,
                reset: 1,
                prev: 1,
                play: false,
                next: 1,
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1,
            },
        });
    };

    const thumbs = shots.map((shot, index) => {
        const imageUri = shot.imageView === "Coding" ? "original" : "normal";
        const url = shot.version === "edited" ? shot.editedImageUris[imageUri] : shot.uneditedImageUris[imageUri];
        const version = props.version === "all" ? `(${shot.version || "unedited"})` : "";

        return (
            <li key={`${props.version}_${index}of${shots.length}`}>
                <img
                    alt={`Product ${shot.imageViewDescription || CODING_SHOT.imageViewDescription}`}
                    src={url}
                />
                <p>
                    {shot.isPremiumEditing && (
                        <span>
                            <FontAwesomeIcon icon={faStar} />{" "}
                        </span>
                    )}
                    <span>{shot.imageViewDescription || CODING_SHOT.imageViewDescription}</span>
                    <span>
                        {shot.isDefaultEcomShot && shot.localeCode === DEFAULT_LOCALE.value ? "(Ecom) " : ""} {version}
                    </span>
                    <span className="m-l-4">
                        <DownloadImage
                            showIconOnly={true}
                            wipKey={props.wipKey}
                            type={shot.version || "unedited"}
                            shotKey={shot.key}
                            mimeType={mimeType}
                            imageView={shot.imageView}
                        />
                    </span>
                </p>
            </li>
        );
    });

    const gallery =
        shots.length > 0 ? (
            <ul
                id={`image-gallery_${props.wipKey}`}
                className="image-gallery"
                onLoad={onLoad}
            >
                {thumbs}
            </ul>
        ) : (
            <NoShots />
        );

    return <>{gallery}</>;
};

export default ImageGallery;
